/* eslint-disable */
// ─── Ebook Utility Functions ──────────────────────────────────────────────────

// Count words in markdown string (strips markdown syntax first)
export function countWords(markdown = '') {
  return markdown
    .replace(/```[\s\S]*?```/g, '')     // remove code blocks
    .replace(/`[^`]*`/g, '')            // remove inline code
    .replace(/!\[.*?\]\(.*?\)/g, '')    // remove images
    .replace(/\[.*?\]\(.*?\)/g, '')     // remove links
    .replace(/[#*_~>|]/g, '')           // remove markdown symbols
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
}

// Calculate reading speed in WPM
// timeSpentSeconds must be actual active reading time (idle excluded)
export function calcWPM(wordCount, timeSpentSeconds) {
  if (!wordCount || !timeSpentSeconds || timeSpentSeconds < 10) return null;
  const minutes = timeSpentSeconds / 60;
  return Math.round(wordCount / minutes);
}

// Completion percent across all topics
export function calcCompletionPercent(topicsCompleted, topicsTotal) {
  if (!topicsTotal) return 0;
  return Math.round((topicsCompleted / topicsTotal) * 100);
}

// Consistency score based on streak
// streak_days > 7 → 100, otherwise linear
export function calcConsistencyScore(streakDays = 0) {
  if (streakDays >= 7) return 100;
  return Math.round((streakDays / 7) * 100);
}

// Predicted exam score
// Weights: avgScore 50%, completion 30%, consistency 20%
export function calcPredictedScore(avgScore = 0, completionPercent = 0, streakDays = 0) {
  const consistency = calcConsistencyScore(streakDays);
  return Math.round(
    avgScore            * 0.5 +
    completionPercent   * 0.3 +
    consistency         * 0.2
  );
}

// Auto-complete check
// Returns true if student should be marked complete automatically
// readTimeMinutes comes from ebook_topics.read_time_minutes
export function shouldAutoComplete(scrollPercent, timeSpentSeconds, readTimeMinutes) {
  if (!readTimeMinutes) {
    // No read time estimate — just use scroll
    return scrollPercent >= 95;
  }
  const halfReadTimeSeconds = (readTimeMinutes * 60) / 2;
  return scrollPercent >= 90 && timeSpentSeconds >= halfReadTimeSeconds;
}

// Format seconds to human readable
export function fmtDuration(seconds = 0) {
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m < 60) return s > 0 ? `${m}m ${s}s` : `${m}m`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  return rem > 0 ? `${h}h ${rem}m` : `${h}h`;
}

// Scroll percent from a scrollable element
export function getScrollPercent(el) {
  if (!el) return 0;
  const { scrollTop, scrollHeight, clientHeight } = el;
  const scrollable = scrollHeight - clientHeight;
  if (scrollable <= 0) return 100; // content fits — treat as fully read
  return Math.min(100, Math.round((scrollTop / scrollable) * 100));
}